import { createMandatoryContext } from '@change-corgi/core/react/context';

export type UserAgentContextValue = {
	bot: boolean;
};

export const {
	Context: UserAgentContext,
	Provider: UserAgentContextProvider,
	useContext: useUserAgentContext,
} = createMandatoryContext<UserAgentContextValue>(undefined, {
	name: 'UserAgentContext',
});
